module.exports = __webpack_public_path__ + "static/img/pingtaibg2.9e2ec925.png";